export class PerformanceMonitor {
  private frames = 0;
  private elapsed = 0;
  private fps = 60;
  private poorMs = 0;
  enabled = false;

  update(dt: number): number {
    this.frames += 1;
    this.elapsed += dt;
    if (this.elapsed >= 0.5) {
      this.fps = this.frames / this.elapsed;
      this.frames = 0;
      this.elapsed = 0;
      if (this.fps < 40) this.poorMs += 500;
      else this.poorMs = Math.max(0, this.poorMs - 250);
    }
    return this.fps;
  }

  getFps(): number {
    return this.fps;
  }

  shouldDowngrade(): boolean {
    return this.poorMs > 2000;
  }

  shouldUpgrade(): boolean {
    return this.fps > 55 && this.poorMs === 0;
  }
}
